import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import {WorkBook, WorkSheet} from "xlsx";

export function deserializeStringEnum <T extends string, TEnumValue extends string> (candidate: string, enumVariable:{ [key in T]: TEnumValue}, failsafe: boolean = true): TEnumValue
{
	for (let key in enumVariable) {
		if (candidate == enumVariable[key])
		{
			return enumVariable[key];
		}
	}

	if (failsafe)
	{
		return null;
	} else {
		throw new Error (`Invalid serialization for ${enumVariable}: ${candidate}`);
	}

}

export function reformatApiDateString (datestr: string) {
	return `${datestr.substring(8,10)}/${datestr.substring(5,7)}/${datestr.substring(0, 4)}`;
}

export function itaDateStringToFileName (datestr: string) {
	return `${datestr.substring(6)}${datestr.substring(3, 5)}${datestr.substring(0, 2)}`;
}

export function dateAsYYYYMMDD (date: Date, sep: string = ""): string {
	const monthstr = `${date.getMonth()+1}`.padStart(2, '0');
	const datestr = `${date.getDate()}`.padStart(2, '0');
	return `${date.getFullYear()}${sep}${monthstr}${sep}${datestr}`;
}

export function datetimeAsHHMMSS (date: Date, sep: string = ""): string {
	const hours = `${date.getHours()}`.padStart(2, '0');
	const minutes = `${date.getMinutes()}`.padStart(2, '0');
	const seconds = `${date.getSeconds()}`.padStart(2, '0');
	return `${hours}${sep}${minutes}${sep}${seconds}`;
}

export function dateAsDDMMYYYY (date: Date, sep: string = "-"): string {
	const monthstr = `${date.getMonth()+1}`.padStart(2, '0');
	const datestr = `${date.getDate()}`.padStart(2, '0');
	return `${datestr}${sep}${monthstr}${sep}${date.getFullYear()}`;
}

export function dateFromYYYYMMDDsep (datestr: string, sep?: string) {
	const sepLen = sep ? sep.length : 1;
	const year = datestr.substring(0,4);
	const month = datestr.substring(4 + sepLen, 6 + sepLen);
	const day = datestr.substring(6 + (sepLen * 2), 8 + (sepLen * 2));
	return new Date(parseInt(year), parseInt(month)-1, parseInt(day));

}

export function clearStringToMinimal (src: string) {
	return src.toLowerCase().trim().split("").filter((letter) => {
		return "qwertyuiopasdfghjklzxcvbnm1234567890".split("").indexOf(letter) != -1
	}).join("");
}

export function asTrimNulledString (src: string) {
	const clean = `${(src ?? "")}`.trim();
	return clean.length > 0 ? clean : null;
}

export function asNulledInt (src: any) {
	const value = parseInt(src);
	return isNaN(value) ? null :value;
}

export interface MagazzinoUserSummary {
	idImpresa:			number;
	isAzienda:			boolean;
	isAdmin:			boolean;
	isSmartFiber:		boolean;
	isPresidio:			boolean;
}

// this is for dev side only when user is accessing an internal page directly but after login?
export function getMagazzinoUserSummary () {

    const isLoggedIn = localStorage.getItem("isLoggedIn");
    if (isLoggedIn === "true") {
		const ruolo = localStorage.getItem("ruolo");
		const ragSoc = localStorage.getItem("ragioneSocialeAzienda") || "";
		return {
			isAzienda: localStorage.getItem("isAzienda") === "true",
			idImpresa: parseInt(localStorage.getItem("idAzienda")) || 0,
			isSmartFiber: ragSoc == "SMARTFIBER" || ruolo == "SMARTFIBER",
			isAdmin: ruolo == "ADMIN" || ruolo == "SUPERADMIN",
			isPresidio: ruolo == "PRESIDIO",
		}
    }
	else {
		return null;
	}
}

export function exportDataToXlsx (fields: string[], data: {[key: string]: any}[], headermap?: {[key: string]: string}, name?: string): WorkBook {
	const headers = fields.map((item) => { return (headermap ?? {})[item] ?? item; });
	const as_array = data.map((item) => {
		return fields.map((field) => {
			return item[field] ?? "";
		})
	});

	const worksheet: WorkSheet = XLSX.utils.aoa_to_sheet([headers, ...as_array]);
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, name ?? "Sheet1");
	return workbook;
}

export function downloadXlsxWorkbook (wb: WorkBook, filename: string) {
	const excelBuffer: any = XLSX.write(wb, {
		bookType: 'xlsx',
		type: 'array',
	});

	const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
	saveAs(blob, filename);

}

export function colsToObject (colnames: string[], values: any[]) {
	const out = {};
	for (let i = 0; i < colnames.length; i++) {
		out[colnames[i]] = values[i] ?? null;
	}
	return out;
}

export function readXlsxUploadAsTable (srcfile: File, callback: (data: { sheets: XlsxParsedSheet[] }) => void) {

	const reader = new FileReader();
		reader.onload = (event: ProgressEvent<FileReader>) => {
		const rawdata = event.target.result;
		const wb: XLSX.WorkBook = XLSX.read(rawdata, {type: "binary"});

		const parsed: XlsxParsedSheet[] = [];
		for (let sheetName of wb.SheetNames) {
			const wsh = wb.Sheets[sheetName];
			let excelsheetdata = XLSX.utils.sheet_to_json(wsh);
			// console.log("sheet data", excelsheetdata);
			parsed.push({
				title: sheetName,
				columns: Object.keys(excelsheetdata[0]),
				values: [...excelsheetdata]
			})
		}
		callback({
			sheets: parsed
		});
	};

	reader.readAsBinaryString(srcfile);


}

export interface XlsxParsedSheet {
	title:						string;
	columns:					string[];
	values:						{[key: string]: any}[];
}

export function ensureObjectBreadCrumbValue (src: object, value: any, keys: string[]) {
	const ckey = keys.shift();
	if (!src.hasOwnProperty(ckey)) {
		if (keys.length > 0) {
			src[ckey] = {};
		} else {
			src[ckey] = value;
		}
	}

	if (keys.length > 0) {
		ensureObjectBreadCrumbValue(src[ckey], value, keys);
	}
}

export function listToDict (items: object[], key: string) {
	return Object.fromEntries(items.map((item) => {
		return [item[key], item]
	}));
}